//block
export const GET_LIST_BLOCKS = '/miniapp/get-blocks';
export const GET_BLOCK_INFO = '/miniapp/get-block';
export const CREATE_BLOCK = '/miniapp/create-block';
export const UPDATE_BLOCK = '/miniapp/update-block';
export const DELETE_BLOCK = '/miniapp/delete-block';

//block-item
export const GET_LIST_BLOCK_ITEMS = '/miniapp/get-blockitems';
export const GET_BLOCK_ITEM_INFO = '/miniapp/get-blockitem';
export const CREATE_BLOCK_ITEM = '/miniapp/create-blockitem';
export const UPDATE_BLOCK_ITEM = '/miniapp/update-blockitem';
export const DELETE_BLOCK_ITEM = '/miniapp/delete-blockitem';

//tags
export const GET_LIST_TAGS = '/miniapp/get-tags';
export const GET_TAG_INFO = '/miniapp/get-tag';
export const CREATE_TAG = '/miniapp/create-tag';
export const UPDATE_TAG = '/miniapp/update-tag';
export const DELETE_TAG = '/miniapp/delete-tag';

//miniapps
export const GET_LIST_MINIAPPS = '/miniapp/get-miniapps';
export const GET_MINIAPP_INFO = '/miniapp/get-miniapp';
export const CREATE_MINIAPP = '/miniapp/create-miniapp';
export const UPDATE_MINIAPP = '/miniapp/update-miniapp';
export const DELETE_MINIAPP = '/miniapp/delete-miniapp';

//partner
export const GET_LIST_PARTNERS = '/miniapp/get-partners';
export const GET_PARTNER_INFO = '/miniapp/get-partner';
export const CREATE_PARTNER = '/miniapp/create-partner';
export const UPDATE_PARTNER = '/miniapp/update-partner';
export const DELETE_PARTNER = '/miniapp/delete-partner';

//reconciliation
export const GET_LIST_RECONCILIATION = '/miniapp/reconcile-order';

// video
export const GET_LIST_VIDEOS = '/video/get-videos';
export const GET_VIDEO_INFO = '/video/get-video';
export const CREATE_VIDEO = '/video/create-video';
export const UPDATE_VIDEO = '/video/update-video';
export const DELETE_VIDEO = '/video/delete-video';

// block video
export const GET_LIST_BLOCKS_VIDEO = '/video/get-blocks';
export const GET_BLOCK_VIDEO_INFO = '/video/get-block';
export const CREATE_BLOCK_VIDEO = '/video/create-block';
export const UPDATE_BLOCK_VIDEO = '/video/update-block';
export const DELETE_BLOCK_VIDEO = '/video/delete-block';
export const UPDATE_BLOCK_POSITION ='/video/update-block-positions'

// tag video
export const GET_LIST_TAGS_VIDEO = '/video/get-tags';
export const GET_TAG_VIDEO_INFO = '/video/get-tag';
export const CREATE_TAG_VIDEO = '/video/create-tag';
export const UPDATE_TAG_VIDEO = '/video/update-tag';
export const DELETE_TAG_VIDEO = '/video/delete-tag';
export const UPDATE_TAG_POSITION ='/video/update-tag-positions'

// position video
export const GET_LIST_POSITIONS_VIDEO = '/video/get-positions';
export const GET_POSITION_VIDEO_INFO = '/video/get-position';
export const CREATE_POSITION_VIDEO = '/video/create-position';
export const UPDATE_POSITION_VIDEO = '/video/update-position';
export const DELETE_POSITION_VIDEO = '/video/delete-position';

// common video
export const GET_ALL_BLOCKS_VIDEO = '/video/common/get-blocks';
export const GET_ALL_TAGS_VIDEO = '/video/common/get-tags';
export const GET_ALL_VIDEOS = '/video/common/get-videos';
export const GET_ALL_DISPLAY_PAGE = '/video/common/get-display-pages';
export const GET_TOKEN_TO_UPLOAD = '/video/common/get-token-to-upload';

// common web
export const GET_ALL_BLOGS_WEB = '/website/get-blogs';
export const CREATE_CATEGORY_WEB = '/website/create-category';
export const UPDATE_CATEGORY_WEB = '/website/update-category';
export const DELETE_CATEGORY_WEB = '/website/delete-category';
export const SEARCH_CATEGORY_WEB = '/website/search-category';
export const GET_POST_WEB = '/website/get-post';
export const CREATE_POST_WEB = '/website/create-post';
export const UPDATE_POST_WEB = '/website/update-post';
export const DELETE_POST_WEB = '/website/delete-post';
// export const GET_ALL_TAGS_WEB = '/website/common/get-tags';
// export const GET_ALL_VIDEOS = '/website/common/get-videos';
// export const GET_ALL_DISPLAY_PAGE = '/website/common/get-display-pages';
// export const GET_TOKEN_TO_UPLOAD = '/website/common/get-token-to-upload';

//auth
export const LOGIN = '/auth/login';
export const LOGOUT = '/auth/logout';
export const REFRESH_SESSION = '/auth/refresh-session';
export const UPDATE_PROFILE = '/admin/update';


// admin management
export const GET_LIST_ACCOUNT = '/list-account';
export const DELETE_ACCOUNT = '/delete-account';
export const UPDATE_ACCOUNT = '/update-account';
export const CREATE_ACCOUNT = '/create-account';

//role
export const GET_LIST_ROLE = '/list-roles';
export const DELETE_ROLE = '/delete-role';
export const UPDATE_ROLE = '/update-role';
export const CREATE_ROLE = '/create-role';

//permission
export const GET_LIST_PERMISSION = '/list-permission';
export const DELETE_PERMISSION = '/delete-permission';
export const UPDATE_PERMISSION = '/update-permission';
export const CREATE_PERMISSION = '/create-permission';


// ========== Premium Module ==========

//service
export const GET_LIST_SERVICES = '/miniapp/get-services';
export const GET_SERVICE_INFO = '/miniapp/get-service';
export const CREATE_SERVICE = '/miniapp/create-service';
export const UPDATE_SERVICE = '/miniapp/update-service';
export const DELETE_SERVICE = '/miniapp/delete-service';
export const LIST_ACTIVE_SERVICES = '/miniapp/list-active-services';
export const LIST_ALL_ACTIVE_SERVICES = '/miniapp/list-all-active-services';

//service-ldp
export const GET_LIST_SERVICE_LDPS = '/miniapp/get-service-ldps';
export const GET_SERVICE_LDP_INFO = '/miniapp/get-service-ldp';
export const CREATE_SERVICE_LDP = '/miniapp/create-service-ldp';
export const UPDATE_SERVICE_LDP = '/miniapp/update-service-ldp';
export const DELETE_SERVICE_LDP = '/miniapp/delete-service-ldp';

//premium-type
export const GET_LIST_PREMIUM_TYPES = '/miniapp/get-premium-types';
export const GET_PREMIUM_TYPE_INFO = '/miniapp/get-premium-type';
export const CREATE_PREMIUM_TYPE = '/miniapp/create-premium-type';
export const UPDATE_PREMIUM_TYPE = '/miniapp/update-premium-type';
export const DELETE_PREMIUM_TYPE = '/miniapp/delete-premium-type';
export const LIST_ACTIVE_PREMIUM_TYPES = '/miniapp/list-active-premium-types';

//premium-order
export const GET_LIST_PREMIUM_ORDERS = '/miniapp/get-premium-orders';
export const GET_PREMIUM_ORDER_INFO = '/miniapp/get-premium-order';
export const CREATE_PREMIUM_ORDER = '/miniapp/create-premium-order';
export const UPDATE_PREMIUM_ORDER = '/miniapp/update-premium-order';
export const DELETE_PREMIUM_ORDER = '/miniapp/delete-premium-order';
export const CHANGE_ALL_PREMIUM_ORDERS = '/miniapp/change-all-premium-orders';
export const ASSIGN_STAFF_PREMIUM_ORDER = '/miniapp/assign-staff-premium-order';
export const GET_PREMIUM_ORDER_OPTIONS = '/miniapp/get-premium-order-options';
export const EXPORT_PREMIUM_ORDERS = '/miniapp/export-premium-orders';
export const IMPORT_PREMIUM_ORDERS = '/miniapp/import-premium-orders';
export const CHECK_APPLE_ORDER_ID = '/miniapp/check-apple-order-id';
export const BULK_ASSIGN_STAFF = '/miniapp/bulk-assign-staff';

//premium
export const GET_LIST_PREMIUMS = '/miniapp/get-premiums';
export const GET_PREMIUM_INFO = '/miniapp/get-premium';
export const CREATE_PREMIUM = '/miniapp/create-premium';
export const UPDATE_PREMIUM = '/miniapp/update-premium';
export const DELETE_PREMIUM = '/miniapp/delete-premium';
export const CHECK_PREMIUM = '/miniapp/check-premium';

//user-feature
export const GET_LIST_USER_FEATURES = '/miniapp/get-user-features';
export const GET_USER_FEATURE_INFO = '/miniapp/get-user-feature';
export const CREATE_USER_FEATURE = '/miniapp/create-user-feature';
export const UPDATE_USER_FEATURE = '/miniapp/update-user-feature';
export const DELETE_USER_FEATURE = '/miniapp/delete-user-feature';
export const LIST_FEATURES = '/miniapp/list-features';

//feature (tính năng)
export const GET_LIST_FEATURES = '/miniapp/get-features';
export const GET_FEATURE_INFO = '/miniapp/get-feature';
export const CREATE_FEATURE = '/miniapp/create-feature';
export const UPDATE_FEATURE = '/miniapp/update-feature';
export const DELETE_FEATURE = '/miniapp/delete-feature';
export const LIST_ACTIVE_FEATURES = '/miniapp/list-active-features';

//history-premium
export const GET_LIST_HISTORY_PREMIUMS = '/miniapp/get-history-premiums';
export const CHANGE_HISTORY_PREMIUM_STATUS = '/miniapp/change-history-premium-status';
export const LIST_GROUP_SERVICES = '/miniapp/list-group-services';

//upload
export const UPLOAD_IMAGE = '/miniapp/upload-image';

//mb-push-noti-transactions
export const GET_LIST_MB_PUSH_NOTI_TRANSACTIONS = '/miniapp/get-mb-push-noti-transactions';

//store-notifications
export const GET_LIST_STORE_NOTIFICATIONS = '/miniapp/get-store-notifications';
export const REPLAY_STORE_NOTIFICATION = '/miniapp/replay-store-notification';

//campaigns
export const LIST_ACTIVE_CAMPAIGNS = '/miniapp/list-active-campaigns';

// ========== Object & Event Module ==========

//event-type (thể loại sự kiện)
export const GET_LIST_EVENT_TYPES = '/miniapp/get-event-types';
export const GET_EVENT_TYPE_INFO = '/miniapp/get-event-type';
export const CREATE_EVENT_TYPE = '/miniapp/create-event-type';
export const UPDATE_EVENT_TYPE = '/miniapp/update-event-type';
export const DELETE_EVENT_TYPE = '/miniapp/delete-event-type';
export const LIST_ACTIVE_EVENT_TYPES = '/miniapp/list-active-event-types';

//event-category (danh mục sự kiện)
export const GET_LIST_EVENT_CATEGORIES = '/miniapp/get-event-categories';
export const GET_EVENT_CATEGORY_INFO = '/miniapp/get-event-category';
export const CREATE_EVENT_CATEGORY = '/miniapp/create-event-category';
export const UPDATE_EVENT_CATEGORY = '/miniapp/update-event-category';
export const DELETE_EVENT_CATEGORY = '/miniapp/delete-event-category';
export const LIST_ACTIVE_EVENT_CATEGORIES = '/miniapp/list-active-event-categories';

//event (sự kiện hệ thống)
export const GET_LIST_EVENTS = '/miniapp/get-events';
export const GET_EVENT_INFO = '/miniapp/get-event';
export const CREATE_EVENT = '/miniapp/create-event';
export const UPDATE_EVENT = '/miniapp/update-event';
export const DELETE_EVENT = '/miniapp/delete-event';
export const IMPORT_EVENTS = '/miniapp/import-events';

//user-event (sự kiện người dùng)
export const GET_LIST_USER_EVENTS = '/miniapp/get-user-events';
export const GET_USER_EVENT_INFO = '/miniapp/get-user-event';
export const CREATE_USER_EVENT = '/miniapp/create-user-event';
export const UPDATE_USER_EVENT = '/miniapp/update-user-event';
export const DELETE_USER_EVENT = '/miniapp/delete-user-event';

//object-type (loại đối tượng)
export const GET_LIST_OBJECT_TYPES = '/miniapp/get-object-types';
export const GET_OBJECT_TYPE_INFO = '/miniapp/get-object-type';
export const CREATE_OBJECT_TYPE = '/miniapp/create-object-type';
export const UPDATE_OBJECT_TYPE = '/miniapp/update-object-type';
export const DELETE_OBJECT_TYPE = '/miniapp/delete-object-type';
export const LIST_ACTIVE_OBJECT_TYPES = '/miniapp/list-active-object-types';

//object (đối tượng)
export const GET_LIST_OBJECTS = '/miniapp/get-objects';
export const GET_OBJECT_INFO = '/miniapp/get-object';
export const CREATE_OBJECT = '/miniapp/create-object';
export const UPDATE_OBJECT = '/miniapp/update-object';
export const DELETE_OBJECT = '/miniapp/delete-object';
export const LIST_COUNTRIES = '/miniapp/list-countries';

//user lookup
export const GET_USER_BY_ID = '/miniapp/get-user-by-id';
export const SEARCH_USERS = '/miniapp/search-users';

export const GET_CAMPAIGN_LIST = '/video/common/get-campaigns';

// ========== Quản trị nội dung ==========

// Content Category (Danh mục nội dung)
export const GET_LIST_CONTENT_CATEGORIES = '/miniapp/get-content-categories';
export const GET_CONTENT_CATEGORY_INFO = '/miniapp/get-content-category';
export const CREATE_CONTENT_CATEGORY = '/miniapp/create-content-category';
export const UPDATE_CONTENT_CATEGORY = '/miniapp/update-content-category';
export const DELETE_CONTENT_CATEGORY = '/miniapp/delete-content-category';
export const LIST_ACTIVE_CONTENT_CATEGORIES = '/miniapp/list-active-content-categories';

// Post (Bài viết)
export const GET_LIST_POSTS = '/miniapp/get-posts';
export const GET_POST_INFO = '/miniapp/get-post';
export const CREATE_POST = '/miniapp/create-post';
export const UPDATE_POST = '/miniapp/update-post';
export const DELETE_POST = '/miniapp/delete-post';

// Album
export const GET_LIST_ALBUMS = '/miniapp/get-albums';
export const GET_ALBUM_INFO = '/miniapp/get-album';
export const CREATE_ALBUM = '/miniapp/create-album';
export const UPDATE_ALBUM = '/miniapp/update-album';
export const DELETE_ALBUM = '/miniapp/delete-album';
export const LIST_ACTIVE_ALBUMS = '/miniapp/list-active-albums';

// Image (Hình ảnh)
export const GET_LIST_IMAGES = '/miniapp/get-images';
export const GET_IMAGE_INFO = '/miniapp/get-image';
export const CREATE_IMAGE = '/miniapp/create-image';
export const UPDATE_IMAGE = '/miniapp/update-image';
export const DELETE_IMAGE = '/miniapp/delete-image';

// Content Video
export const GET_LIST_CONTENT_VIDEOS = '/miniapp/get-content-videos';
export const GET_CONTENT_VIDEO_INFO = '/miniapp/get-content-video';
export const CREATE_CONTENT_VIDEO = '/miniapp/create-content-video';
export const UPDATE_CONTENT_VIDEO = '/miniapp/update-content-video';
export const DELETE_CONTENT_VIDEO = '/miniapp/delete-content-video';

// File (Quản lý file)
export const GET_LIST_FILES = '/miniapp/get-files';
export const GET_FILE_INFO = '/miniapp/get-file';
export const CREATE_FILE = '/miniapp/create-file';
export const UPDATE_FILE = '/miniapp/update-file';
export const DELETE_FILE = '/miniapp/delete-file';

// Idiom (Danh ngôn)
export const GET_LIST_IDIOMS = '/miniapp/get-idioms';
export const GET_IDIOM_INFO = '/miniapp/get-idiom';
export const CREATE_IDIOM = '/miniapp/create-idiom';
export const UPDATE_IDIOM = '/miniapp/update-idiom';
export const DELETE_IDIOM = '/miniapp/delete-idiom';
export const IMPORT_IDIOMS = '/miniapp/import-idioms';

// Heroscop (Cung hoàng đạo)
export const GET_LIST_HEROSCOPS = '/miniapp/get-heroscops';
export const GET_HEROSCOP_INFO = '/miniapp/get-heroscop';
export const CREATE_HEROSCOP = '/miniapp/create-heroscop';
export const UPDATE_HEROSCOP = '/miniapp/update-heroscop';
export const DELETE_HEROSCOP = '/miniapp/delete-heroscop';

// Horoscop (Tử vi)
export const GET_LIST_HOROSCOPS = '/miniapp/get-horoscops';
export const GET_HOROSCOP_INFO = '/miniapp/get-horoscop';
export const CREATE_HOROSCOP = '/miniapp/create-horoscop';
export const UPDATE_HOROSCOP = '/miniapp/update-horoscop';
export const DELETE_HOROSCOP = '/miniapp/delete-horoscop';
export const RESET_HOROSCOP_DATA = '/miniapp/reset-horoscop-data';

// Card (Thiệp)
export const GET_LIST_CARDS = '/miniapp/get-cards';
export const GET_CARD_INFO = '/miniapp/get-card';
export const CREATE_CARD = '/miniapp/create-card';
export const UPDATE_CARD = '/miniapp/update-card';
export const DELETE_CARD = '/miniapp/delete-card';

// Content List (Danh sách)
export const GET_LIST_CONTENT_LISTS = '/miniapp/get-content-lists';
export const GET_CONTENT_LIST_INFO = '/miniapp/get-content-list';
export const CREATE_CONTENT_LIST = '/miniapp/create-content-list';
export const UPDATE_CONTENT_LIST = '/miniapp/update-content-list';
export const DELETE_CONTENT_LIST = '/miniapp/delete-content-list';
export const LIST_SEARCH_OBJECTS = '/miniapp/list-search-objects';
export const LIST_RESOLVE_OBJECTS = '/miniapp/list-resolve-objects';

// statistics video
export const GET_DATA_STATISTICS = '/video/data_statistics';
export const GET_GRAPHICAL_STATISTICS = '/video/graphical_statistics';
export const GET_DIMENSIONS_METRICS = '/video/statistics-attributes';

// Survey
export const GET_LIST_SURVEYS = '/survey/get-surveys';
export const GET_SURVEY_INFO = '/survey/get-detail-survey';
export const CREATE_SURVEY = '/survey/create-survey';
export const UPDATE_SURVEY = '/survey/update-survey';
export const DELETE_SURVEY = '/survey/delete-survey';

// Feature Rating Config (Khảo sát tính năng hữu ích)
export const GET_LIST_FEATURE_RATING_CONFIGS = '/survey/get-feature-rating-configs';
export const GET_DETAIL_FEATURE_RATING_CONFIG = '/survey/get-detail-feature-rating-config';
export const CREATE_FEATURE_RATING_CONFIG = '/survey/create-feature-rating-config';
export const UPDATE_FEATURE_RATING_CONFIG = '/survey/update-feature-rating-config';
export const DELETE_FEATURE_RATING_CONFIG = '/survey/delete-feature-rating-config';

// Góp ý với Lịch Việt
export const GET_LIST_FEEDBACK_FEATURE_CONFIGS = '/survey/get-feedback-feature-configs';
export const CREATE_FEEDBACK_FEATURE_CONFIG = '/survey/create-feedback-feature-config';
export const UPDATE_FEEDBACK_FEATURE_CONFIG = '/survey/update-feedback-feature-config';
export const DELETE_FEEDBACK_FEATURE_CONFIG = '/survey/delete-feedback-feature-config';
export const GET_LIST_SURVEY_FEEDBACKS = '/survey/get-feedbacks';
export const UPDATE_SURVEY_FEEDBACK_STATUS = '/survey/update-feedback-status';

// User management (regular customer users)
export const GET_LIST_USERS = '/miniapp/get-users';
export const GET_USER_INFO = '/miniapp/get-user';
export const CREATE_USER = '/miniapp/create-user';
export const UPDATE_USER = '/miniapp/update-user';
export const DELETE_USER = '/miniapp/delete-user';
export const MERGE_USER = '/miniapp/merge-user';

// ========== NEXT MODULE ==========
// App Version
export const GET_LIST_APP_VERSIONS = '/next/get-app-versions';
export const GET_APP_VERSION_INFO = '/next/get-app-version';
export const CREATE_APP_VERSION = '/next/create-app-version';
export const UPDATE_APP_VERSION = '/next/update-app-version';
export const DELETE_APP_VERSION = '/next/delete-app-version';
export const SORT_APP_VERSIONS = '/next/sort-app-versions';

// API Version
export const GET_LIST_API_VERSIONS = '/next/get-api-versions';
export const CREATE_API_VERSION = '/next/create-api-version';
export const UPDATE_API_VERSION = '/next/update-api-version';

// App Rate
export const GET_LIST_APP_RATES = '/next/get-app-rates';

// Feedback
export const GET_LIST_FEEDBACKS = '/next/get-feedbacks';

// Config
export const GET_LIST_CONFIGS = '/next/get-configs';
export const GET_CONFIG_INFO = '/next/get-config';
export const GET_CONFIG_AUDIENCES = '/next/get-config-audiences';
export const CREATE_CONFIG = '/next/create-config';
export const UPDATE_CONFIG = '/next/update-config';
export const DELETE_CONFIG = '/next/delete-config';
export const CHANGE_CONFIG_STATUS = '/next/change-config-status';
export const SORT_CONFIGS = '/next/sort-configs';
export const COPY_CONFIG = '/next/copy-config';

// Remote Config - Tập khách hàng (biểu thức boolean)
export const GET_LIST_AUDIENCE_GROUPS = '/next/get-audience-groups';
export const GET_AUDIENCE_GROUP = '/next/get-audience-group';
export const CREATE_AUDIENCE_GROUP = '/next/create-audience-group';
export const UPDATE_AUDIENCE_GROUP = '/next/update-audience-group';
export const DELETE_AUDIENCE_GROUP = '/next/delete-audience-group';
export const CHANGE_AUDIENCE_GROUP_STATUS = '/next/change-audience-group-status';
export const GET_AUDIENCE_GROUP_USAGE = '/next/get-audience-group-usage';
export const VALIDATE_AUDIENCE_EXPRESSION = '/next/validate-audience-expression';

// Remote Config - Lịch sử & Time-travel
export const GET_CONFIG_HISTORY = '/next/get-config-history';
export const GET_CONFIG_EVENT = '/next/get-config-event';
export const GET_CONFIG_TIMELINE = '/next/get-config-timeline';
export const GET_CONFIG_HISTORY_META = '/next/get-config-history-meta';
export const RESOLVE_CONFIGS = '/next/resolve-configs';
export const DIFF_CONFIGS = '/next/diff-configs';

// Utility Banner
export const GET_LIST_UTILITY_BANNERS = '/next/get-utilities-banner';
export const GET_UTILITY_BANNER_INFO = '/next/get-utility-banner';
export const CREATE_UTILITY_BANNER = '/next/create-utility-banner';
export const UPDATE_UTILITY_BANNER = '/next/update-utility-banner';
export const DELETE_UTILITY_BANNER = '/next/delete-utility-banner';
export const CHANGE_UTILITY_BANNER_STATUS = '/next/change-utility-banner-status';
export const SORT_UTILITY_BANNERS = '/next/sort-utilities-banner';
export const COPY_UTILITY_BANNER = '/next/copy-utility-banner';
export const DELETE_UTILITY_BANNERS = '/next/delete-utility-banners';
export const GET_UTILITY_BANNER_METADATA = '/next/get-utility-banner-metadata';
export const UPDATE_UTILITY_BANNER_TITLE = '/next/update-utility-banner-title';

// Nội dung truyền thông (suggestions) — chuyển từ cms.next /suggestion
export const GET_LIST_SUGGESTIONS = '/next/get-suggestions';
export const GET_SUGGESTION_INFO = '/next/get-suggestions-detail';
export const GET_SUGGESTION_METADATA = '/next/get-suggestions-metadata';
export const CREATE_SUGGESTION = '/next/create-suggestion';
export const UPDATE_SUGGESTION = '/next/update-suggestion';
export const CHANGE_SUGGESTION_STATUS = '/next/update-suggestion-status';
export const DELETE_SUGGESTION = '/next/delete-suggestion';

// Thành viên gia đình (profiles) — chuyển từ cms.next /profiles
export const GET_LIST_PROFILES = '/next/get-profiles';
export const CREATE_PROFILE = '/next/create-profile';
export const UPDATE_FAMILY_PROFILE = '/next/update-profile';
export const DELETE_PROFILE = '/next/delete-profile';
export const DELETE_PROFILES = '/next/delete-profiles';

// Campaign
export const GET_LIST_NEXT_CAMPAIGNS = '/next/get-campaigns';
export const GET_NEXT_CAMPAIGN_INFO = '/next/get-campaign';
export const CREATE_NEXT_CAMPAIGN = '/next/create-campaign';
export const UPDATE_NEXT_CAMPAIGN = '/next/update-campaign';
export const DELETE_NEXT_CAMPAIGN = '/next/delete-campaign';
export const CHANGE_NEXT_CAMPAIGN_STATUS = '/next/change-campaign-status';

// Voucher
export const GET_LIST_VOUCHERS = '/next/get-vouchers';
export const GET_VOUCHER_INFO = '/next/get-voucher';
export const CREATE_VOUCHER = '/next/create-voucher';
export const UPDATE_VOUCHER = '/next/update-voucher';
export const DELETE_VOUCHER = '/next/delete-voucher';
export const CHANGE_VOUCHER_STATUS = '/next/change-voucher-status';
export const GET_VOUCHER_METADATA = '/next/get-voucher-metadata';

// Mental Health Config
export const GET_LIST_MH_CONFIGS = '/next/get-mh-configs';
export const GET_MH_CONFIG_INFO = '/next/get-mh-config';
export const CREATE_MH_CONFIG = '/next/create-mh-config';
export const UPDATE_MH_CONFIG = '/next/update-mh-config';
export const DELETE_MH_CONFIG = '/next/delete-mh-config';
export const CHANGE_MH_CONFIG_STATUS = '/next/change-mh-config-status';

// Service Block (Khối dịch vụ)
export const GET_LIST_SERVICE_BLOCKS = '/next/get-service-blocks';
export const GET_SERVICE_BLOCK_INFO = '/next/get-service-block';
export const CREATE_SERVICE_BLOCK = '/next/create-service-block';
export const UPDATE_SERVICE_BLOCK = '/next/update-service-block';
export const DELETE_SERVICE_BLOCK = '/next/delete-service-block';
export const CHANGE_SERVICE_BLOCK_STATUS = '/next/change-service-block-status';
export const SORT_SERVICE_BLOCKS = '/next/sort-service-blocks';
export const COPY_SERVICE_BLOCK = '/next/copy-service-block';
export const GET_SERVICE_BLOCK_METADATA = '/next/get-service-block-metadata';


